import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// * Shared styles that are standard between the styled blog cards

export const Category = styled.p`
  color: ${themeGet('colors.darkest-orange')};
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.2px;
  line-height: 28px;

  span {
    color: inherit;
    line-height: 24px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 10px;
  }
`;

export const ArticleTitle = styled.h3`
  width: 100%;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  font-size: 12px;
  letter-spacing: 0.15px;
  line-height: 28px;

  margin: 10px -5px;

  &.feature-card {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 28px;

    margin: 20px -5px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Date = styled.time`
  font-family: ${themeGet('fonts.primary')};
  font-size: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0 5px;

  &:after {
    content: '|';
    position: relative;
    right: -5px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Author = styled.p`
  font-size: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0 5px;
`;

export const ArticleAuthor = styled.p`
  display: inline; /* the default for span */
  font-size: inherit;
  letter-spacing: inherit;
  line-height: inherit;

  a,
  a:hover,
  a:active {
    color: #c03a00;
    border-bottom: none;
    font-weight: inherit;
    font-size: inherit;
  }

  span {
    margin-right: 5px;
  }
`;

export const ArticleDate = styled.time`
  font-family: ${themeGet('fonts.primary')};
  font-size: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0 5px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Copy = styled.div`
  margin-bottom: 20px;
  width: 100%;

  p {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  }

  &.small {
    p {
      font-size: 14px;
      letter-spacing: 0;
      line-height: 22px;
    }
  }

  &.large {
    p {
      font-size: 18px;
      font-weight: ${themeGet('font-weights.semi-bold')};
      letter-spacing: -0.41px;
      line-height: 24px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    p {
      font-size: 18px;
      letter-spacing: -0.2px;
      line-height: 30px;
    }

    &.small {
      p {
        font-size: 15px;
        letter-spacing: -0.2px;
        line-height: 25px;
      }
    }

    &.large {
      p {
        font-size: 22px;
        letter-spacing: -0.17px;
        line-height: 32px;
      }
    }
  }
`;
